var _ref2, _ref3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArchive = function SvgArchive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 24,
      height: 25,
      viewBox: "0 0 24 25",
      fill: "#041F47",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M21.0001 6.5C21.0001 5.70435 20.684 4.94129 20.1214 4.37868C19.5588 3.81607 18.7957 3.5 18.0001 3.5H6.00006C5.39605 3.50358 4.80718 3.6894 4.31052 4.03315C3.81385 4.3769 3.43251 4.86257 3.21641 5.42661C3.0003 5.99065 2.95949 6.60679 3.09931 7.1944C3.23913 7.78202 3.55307 8.31374 4.00006 8.72V18.5C4.00006 19.2956 4.31613 20.0587 4.87874 20.6213C5.44135 21.1839 6.20441 21.5 7.00006 21.5H17.0001C17.7957 21.5 18.5588 21.1839 19.1214 20.6213C19.684 20.0587 20.0001 19.2956 20.0001 18.5V8.72C20.3127 8.44042 20.5632 8.09839 20.7354 7.71601C20.9077 7.33363 20.9978 6.91938 21.0001 6.5ZM6.00006 5.5H18.0001C18.2653 5.5 18.5196 5.60536 18.7072 5.79289C18.8947 5.98043 19.0001 6.23478 19.0001 6.5C19.0001 6.76522 18.8947 7.01957 18.7072 7.20711C18.5196 7.39464 18.2653 7.5 18.0001 7.5H6.00006C5.73484 7.5 5.48049 7.39464 5.29295 7.20711C5.10542 7.01957 5.00006 6.76522 5.00006 6.5C5.00006 6.23478 5.10542 5.98043 5.29295 5.79289C5.48049 5.60536 5.73484 5.5 6.00006 5.5ZM18.0001 18.5C18.0001 18.7652 17.8947 19.0196 17.7072 19.2071C17.5196 19.3946 17.2653 19.5 17.0001 19.5H7.00006C6.73484 19.5 6.48049 19.3946 6.29295 19.2071C6.10542 19.0196 6.00006 18.7652 6.00006 18.5V9.5H18.0001V18.5Z"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.13 12.5H9.87C9.38951 12.5 9 12.8895 9 13.37V13.63C9 14.1105 9.38951 14.5 9.87 14.5H14.13C14.6105 14.5 15 14.1105 15 13.63V13.37C15 12.8895 14.6105 12.5 14.13 12.5Z"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgArchive, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/archive.aad5d4e4.svg";
export { ForwardRef as ReactComponent };